// extracted by mini-css-extract-plugin
export default {"headerSection":"b3Xw5T","themeBrand":"c3Xw5T","component":"d3Xw5T","appBar":"e3Xw5T","content":"f3Xw5T","headerVariationTest":"g3Xw5T","logoBig":"h3Xw5T"};